







export default {
  name: 'FireBallIcon',
  props: {
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }

}
